import type { MutationTree } from 'vuex';
import type { Answer } from '@/types/models/answer';
import type { ScopingAnswer } from '@/types/models/scopingAnswer';
import type { AssessmentStatus } from '@/types/models/assessmentStatus';
import type { ReassessmentStatus } from '@/types/models/reassessment';

const initialState = () => ({
  controlAnswers: {} as Record<string, Answer>,
  scopingAnswers: {} as Record<string, ScopingAnswer>,
  status: {} as AssessmentStatus,
  reassessmentStatus: {} as ReassessmentStatus,
});

export const state = initialState();
export type AssessmentState = typeof state;

export const mutations: MutationTree<AssessmentState> = {
  SET_ASSESSMENT_STATUS(state, data: AssessmentState['status']) {
    // Round assessment status percentage down to an integer.
    data.assessmentProgress = Math.floor(data.assessmentProgress);
    state.status = data;
  },
  SET_SCOPING_ANSWERS(state, data: AssessmentState['scopingAnswers']) {
    state.scopingAnswers = data;
  },
  SET_CONTROL_ANSWERS(state, data: AssessmentState['controlAnswers']) {
    state.controlAnswers = data;
  },
  CLEAR_STATE(state) {
    Object.assign(state, initialState());
  },
};
